import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TryVideo extends Vue {
    @Prop() readonly item: any;
    private flag: boolean = true;
    handleVideoClick() {
        let video = document.getElementById("videoPlay");
        // @ts-ignore  忽略类型。强制转<HTMLVideoElement>报错
        if (video.paused) {
            // @ts-ignore
            video.play();
            this.flag = false;
        }
        let that = this;
        // @ts-ignore
        video.ontimeupdate = function() {
            // @ts-ignore
            that.flag = video.paused;
        };
    }
}
// @ts-ignore
export { default as TryVideo } from "./index.vue";
